<template>
  <div>
    <!-- Route List Table -->
    <div class="base-demo">
      <vue-table-dynamic :params="params" @row-click="rowClicked">
      </vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import {
  getShortTimeFromTicks,
  maskIfEquealsValue,
  getDateFromTicks,
} from "../../_helpers/arrangers";

import { colors } from "../../_helpers/colors";

export default {
  name: "RouteListTable",

  props: {
    data: Array,
  },

  watch: {
    data: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);

      this.resetUi();
      this.fill();
    },
  },

  data() {
    return {
      params: {
        data: [
          [
            "n.",
            "Vozilo",
            "Vozač",
            "Suvozač",
            "Ruta",
            "Početak",
            "Kraj",
            "Trajanje",
            "Pređeno km",
            "Potrošeno goriva",
          ],
        ],
        header: "row",
        enableSearch: true,
        search: this.mySearchFunction("paja", [], []),
        sort: [0, 1, 2, 4, 5, 6, 7, 8, 9],
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 35 },
          { column: 5, width: 70 },
          { column: 6, width: 70 },
          { column: 7, width: 70 },
          { column: 8, width: 100 },
        ],
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { column: [1], row: [0, -1] },
        highlightedColor: colors[6],
        sumIncludeInSearch: true,
        sumSecretPhrase: "Σ",
        sumColumns: [
          { column: 0, type: "increment" },
          { column: 7, type: "time" },
          { column: 8, type: "decimal" },
        ],
      },
    };
  },

  methods: {
    resetUi() {
      console.log("RESET");
      this.params.data = [
        [
          "n.",
          "Vozilo",
          "Vozač",
          "Suvozač",
          "Ruta",
          "Početak",
          "Kraj",
          "Trajanje",
          "Pređeno km",
          "Potrošeno goriva",
        ],
      ];
    },

    fill() {
      let ndx = 0;
      let totalValue = new Array(10).fill(0);

      this.data.forEach((log) => {
        console.log("log", log);
        totalValue[0] += log.duration;
        totalValue[1] += log.kilometerSpent;
        this.params.data.push([
          ++ndx,
          log.vehicleModel,
          log.driverName,
          log.codriverName,
          log.tourName,
          new Date(log.startByGps).toLocaleTimeString("sr-latn-cs"),
          new Date(log.endByGps).toLocaleTimeString("sr-latn-cs"),
          maskIfEquealsValue(getShortTimeFromTicks(log.duration), "00:00"),
          log.kilometerSpent / 1000,
          log.fuelStartL === 0
            ? log.fuelSpent + "%"
            : log.fuelSpentL / 10 + "L",
        ]);
      });

      // push last row
      this.params.data.push([
        "",
        "Σ (za vremenski raspon)",
        "",
        "",
        "",
        "",
        "",
        maskIfEquealsValue(getDateFromTicks(totalValue[0]), "00:00:00"),
        maskIfEquealsValue((totalValue[1] / 1000).toFixed(2), "0"),
        "",
      ]);
    },

    rowClicked(x) {
      console.log("row clicked");
      console.log(this.data[x - 1]);

      this.$emit("rowClicked", this.data[x - 1]);
    },

    mySearchFunction(value, included, excluded) {
      console.log("mySearchFunction: ", value);
      console.log("mySearchFunction: ", included);
      console.log("mySearchFunction: ", excluded);
    },
  },
};
</script>
